export const isoCountryCodes = [
  "AF",
  "AX",
  "AL",
  "DZ",
  "AS",
  "AD",
  "AO",
  "AI",
  "AQ",
  "AG",
  "AR",
  "AM",
  "AW",
  "AU",
  "AT",
  "AZ",
  "BS",
  "BH",
  "BD",
  "BB",
  "BY",
  "BE",
  "BZ",
  "BJ",
  "BM",
  "BT",
  "BO",
  "BA",
  "BW",
  "BV",
  "BR",
  "IO",
  "BN",
  "BG",
  "BF",
  "BI",
  "KH",
  "CM",
  "CA",
  "CV",
  "KY",
  "CF",
  "TD",
  "CL",
  "CN",
  "CX",
  "CC",
  "CO",
  "KM",
  "CG",
  "CD",
  "CK",
  "CR",
  "CI",
  "HR",
  "CU",
  "CY",
  "CZ",
  "DK",
  "DJ",
  "DM",
  "DO",
  "EC",
  "EG",
  "SV",
  "GQ",
  "ER",
  "EE",
  "ET",
  "FK",
  "FO",
  "FJ",
  "FI",
  "FR",
  "GF",
  "PF",
  "TF",
  "GA",
  "GM",
  "GE",
  "DE",
  "GH",
  "GI",
  "GR",
  "GL",
  "GD",
  "GP",
  "GU",
  "GT",
  "GG",
  "GN",
  "GW",
  "GY",
  "HT",
  "HM",
  "VA",
  "HN",
  "HK",
  "HU",
  "IS",
  "IN",
  "ID",
  "IR",
  "IQ",
  "IE",
  "IM",
  "IL",
  "IT",
  "JM",
  "JP",
  "JE",
  "JO",
  "KZ",
  "KE",
  "KI",
  "KP",
  "KR",
  "KW",
  "KG",
  "LA",
  "LV",
  "LB",
  "LS",
  "LR",
  "LY",
  "LI",
  "LT",
  "LU",
  "MO",
  "MK",
  "MG",
  "MW",
  "MY",
  "MV",
  "ML",
  "MT",
  "MH",
  "MQ",
  "MR",
  "MU",
  "YT",
  "MX",
  "FM",
  "MD",
  "MC",
  "MN",
  "MS",
  "MA",
  "MZ",
  "MM",
  "NA",
  "NR",
  "NP",
  "NL",
  "AN",
  "NC",
  "NZ",
  "NI",
  "NE",
  "NG",
  "NU",
  "NF",
  "MP",
  "NO",
  "OM",
  "PK",
  "PW",
  "PS",
  "PA",
  "PG",
  "PY",
  "PE",
  "PH",
  "PN",
  "PL",
  "PT",
  "PR",
  "QA",
  "RE",
  "RO",
  "RU",
  "RW",
  "SH",
  "KN",
  "LC",
  "PM",
  "VC",
  "WS",
  "SM",
  "ST",
  "SA",
  "SN",
  "CS",
  "SC",
  "SL",
  "SG",
  "SK",
  "SI",
  "SB",
  "SO",
  "ZA",
  "GS",
  "ES",
  "LK",
  "SD",
  "SR",
  "SJ",
  "SZ",
  "SE",
  "CH",
  "SY",
  "TW",
  "TJ",
  "TZ",
  "TH",
  "TL",
  "TG",
  "TK",
  "TO",
  "TT",
  "TN",
  "TR",
  "TM",
  "TC",
  "TV",
  "UG",
  "UA",
  "AE",
  "GB",
  "US",
  "UM",
  "UY",
  "UZ",
  "VU",
  "VE",
  "VN",
  "VG",
  "VI",
  "WF",
  "EH",
  "YE",
  "ZM",
  "ZW",
] as const;

export type IsoCountryCode = (typeof isoCountryCodes)[number];

type CountryDefinition = {
  label: string;
  value: IsoCountryCode;
};

const countryDefinitions: readonly CountryDefinition[] = [
  { label: "Afghanistan", value: "AF" },
  { label: "Åland Islands", value: "AX" },
  { label: "Albania", value: "AL" },
  { label: "Algeria", value: "DZ" },
  { label: "American Samoa", value: "AS" },
  { label: "Andorra", value: "AD" },
  { label: "Angola", value: "AO" },
  { label: "Anguilla", value: "AI" },
  { label: "Antarctica", value: "AQ" },
  { label: "Antigua and Barbuda", value: "AG" },
  { label: "Argentina", value: "AR" },
  { label: "Armenia", value: "AM" },
  { label: "Aruba", value: "AW" },
  { label: "Australia", value: "AU" },
  { label: "Austria", value: "AT" },
  { label: "Azerbaijan", value: "AZ" },
  { label: "Bahamas", value: "BS" },
  { label: "Bahrain", value: "BH" },
  { label: "Bangladesh", value: "BD" },
  { label: "Barbados", value: "BB" },
  { label: "Belarus", value: "BY" },
  { label: "Belgium", value: "BE" },
  { label: "Belize", value: "BZ" },
  { label: "Benin", value: "BJ" },
  { label: "Bermuda", value: "BM" },
  { label: "Bhutan", value: "BT" },
  { label: "Bolivia", value: "BO" },
  { label: "Bosnia and Herzegovina", value: "BA" },
  { label: "Botswana", value: "BW" },
  { label: "Bouvet Island", value: "BV" },
  { label: "Brazil", value: "BR" },
  { label: "British Indian Ocean Territory", value: "IO" },
  { label: "Brunei Darussalam", value: "BN" },
  { label: "Bulgaria", value: "BG" },
  { label: "Burkina Faso", value: "BF" },
  { label: "Burundi", value: "BI" },
  { label: "Cambodia", value: "KH" },
  { label: "Cameroon", value: "CM" },
  { label: "Canada", value: "CA" },
  { label: "Cape Verde", value: "CV" },
  { label: "Cayman Islands", value: "KY" },
  { label: "Central African Republic", value: "CF" },
  { label: "Chad", value: "TD" },
  { label: "Chile", value: "CL" },
  { label: "China", value: "CN" },
  { label: "Christmas Island", value: "CX" },
  { label: "Cocos (Keeling) Islands", value: "CC" },
  { label: "Colombia", value: "CO" },
  { label: "Comoros", value: "KM" },
  { label: "Congo", value: "CG" },
  { label: "Congo, The Democratic Republic of the", value: "CD" },
  { label: "Cook Islands", value: "CK" },
  { label: "Costa Rica", value: "CR" },
  { label: "Cote D'Ivoire", value: "CI" },
  { label: "Croatia", value: "HR" },
  { label: "Cuba", value: "CU" },
  { label: "Cyprus", value: "CY" },
  { label: "Czech Republic", value: "CZ" },
  { label: "Denmark", value: "DK" },
  { label: "Djibouti", value: "DJ" },
  { label: "Dominica", value: "DM" },
  { label: "Dominican Republic", value: "DO" },
  { label: "Ecuador", value: "EC" },
  { label: "Egypt", value: "EG" },
  { label: "El Salvador", value: "SV" },
  { label: "Equatorial Guinea", value: "GQ" },
  { label: "Eritrea", value: "ER" },
  { label: "Estonia", value: "EE" },
  { label: "Ethiopia", value: "ET" },
  { label: "Falkland Islands (Malvinas)", value: "FK" },
  { label: "Faroe Islands", value: "FO" },
  { label: "Fiji", value: "FJ" },
  { label: "Finland", value: "FI" },
  { label: "France", value: "FR" },
  { label: "French Guiana", value: "GF" },
  { label: "French Polynesia", value: "PF" },
  { label: "French Southern Territories", value: "TF" },
  { label: "Gabon", value: "GA" },
  { label: "Gambia", value: "GM" },
  { label: "Georgia", value: "GE" },
  { label: "Germany", value: "DE" },
  { label: "Ghana", value: "GH" },
  { label: "Gibraltar", value: "GI" },
  { label: "Greece", value: "GR" },
  { label: "Greenland", value: "GL" },
  { label: "Grenada", value: "GD" },
  { label: "Guadeloupe", value: "GP" },
  { label: "Guam", value: "GU" },
  { label: "Guatemala", value: "GT" },
  { label: "Guernsey", value: "GG" },
  { label: "Guinea", value: "GN" },
  { label: "Guinea-Bissau", value: "GW" },
  { label: "Guyana", value: "GY" },
  { label: "Haiti", value: "HT" },
  { label: "Heard Island and Mcdonald Islands", value: "HM" },
  { label: "Holy See (Vatican City State)", value: "VA" },
  { label: "Honduras", value: "HN" },
  { label: "Hong Kong", value: "HK" },
  { label: "Hungary", value: "HU" },
  { label: "Iceland", value: "IS" },
  { label: "India", value: "IN" },
  { label: "Indonesia", value: "ID" },
  { label: "Iran, Islamic Republic Of", value: "IR" },
  { label: "Iraq", value: "IQ" },
  { label: "Ireland", value: "IE" },
  { label: "Isle of Man", value: "IM" },
  { label: "Israel", value: "IL" },
  { label: "Italy", value: "IT" },
  { label: "Jamaica", value: "JM" },
  { label: "Japan", value: "JP" },
  { label: "Jersey", value: "JE" },
  { label: "Jordan", value: "JO" },
  { label: "Kazakhstan", value: "KZ" },
  { label: "Kenya", value: "KE" },
  { label: "Kiribati", value: "KI" },
  { label: "Korea, Democratic People'S Republic of", value: "KP" },
  { label: "Korea, Republic of", value: "KR" },
  { label: "Kuwait", value: "KW" },
  { label: "Kyrgyzstan", value: "KG" },
  { label: "Lao People'S Democratic Republic", value: "LA" },
  { label: "Latvia", value: "LV" },
  { label: "Lebanon", value: "LB" },
  { label: "Lesotho", value: "LS" },
  { label: "Liberia", value: "LR" },
  { label: "Libyan Arab Jamahiriya", value: "LY" },
  { label: "Liechtenstein", value: "LI" },
  { label: "Lithuania", value: "LT" },
  { label: "Luxembourg", value: "LU" },
  { label: "Macao", value: "MO" },
  { label: "Macedonia, The Former Yugoslav Republic of", value: "MK" },
  { label: "Madagascar", value: "MG" },
  { label: "Malawi", value: "MW" },
  { label: "Malaysia", value: "MY" },
  { label: "Maldives", value: "MV" },
  { label: "Mali", value: "ML" },
  { label: "Malta", value: "MT" },
  { label: "Marshall Islands", value: "MH" },
  { label: "Martinique", value: "MQ" },
  { label: "Mauritania", value: "MR" },
  { label: "Mauritius", value: "MU" },
  { label: "Mayotte", value: "YT" },
  { label: "Mexico", value: "MX" },
  { label: "Micronesia, Federated States of", value: "FM" },
  { label: "Moldova, Republic of", value: "MD" },
  { label: "Monaco", value: "MC" },
  { label: "Mongolia", value: "MN" },
  { label: "Montserrat", value: "MS" },
  { label: "Morocco", value: "MA" },
  { label: "Mozambique", value: "MZ" },
  { label: "Myanmar", value: "MM" },
  { label: "Namibia", value: "NA" },
  { label: "Nauru", value: "NR" },
  { label: "Nepal", value: "NP" },
  { label: "Netherlands", value: "NL" },
  { label: "Netherlands Antilles", value: "AN" },
  { label: "New Caledonia", value: "NC" },
  { label: "New Zealand", value: "NZ" },
  { label: "Nicaragua", value: "NI" },
  { label: "Niger", value: "NE" },
  { label: "Nigeria", value: "NG" },
  { label: "Niue", value: "NU" },
  { label: "Norfolk Island", value: "NF" },
  { label: "Northern Mariana Islands", value: "MP" },
  { label: "Norway", value: "NO" },
  { label: "Oman", value: "OM" },
  { label: "Pakistan", value: "PK" },
  { label: "Palau", value: "PW" },
  { label: "Palestinian Territory, Occupied", value: "PS" },
  { label: "Panama", value: "PA" },
  { label: "Papua New Guinea", value: "PG" },
  { label: "Paraguay", value: "PY" },
  { label: "Peru", value: "PE" },
  { label: "Philippines", value: "PH" },
  { label: "Pitcairn", value: "PN" },
  { label: "Poland", value: "PL" },
  { label: "Portugal", value: "PT" },
  { label: "Puerto Rico", value: "PR" },
  { label: "Qatar", value: "QA" },
  { label: "Reunion", value: "RE" },
  { label: "Romania", value: "RO" },
  { label: "Russian Federation", value: "RU" },
  { label: "Rwanda", value: "RW" },
  { label: "Saint Helena", value: "SH" },
  { label: "Saint Kitts and Nevis", value: "KN" },
  { label: "Saint Lucia", value: "LC" },
  { label: "Saint Pierre and Miquelon", value: "PM" },
  { label: "Saint Vincent and the Grenadines", value: "VC" },
  { label: "Samoa", value: "WS" },
  { label: "San Marino", value: "SM" },
  { label: "Sao Tome and Principe", value: "ST" },
  { label: "Saudi Arabia", value: "SA" },
  { label: "Senegal", value: "SN" },
  { label: "Serbia and Montenegro", value: "CS" },
  { label: "Seychelles", value: "SC" },
  { label: "Sierra Leone", value: "SL" },
  { label: "Singapore", value: "SG" },
  { label: "Slovakia", value: "SK" },
  { label: "Slovenia", value: "SI" },
  { label: "Solomon Islands", value: "SB" },
  { label: "Somalia", value: "SO" },
  { label: "South Africa", value: "ZA" },
  { label: "South Georgia and the South Sandwich Islands", value: "GS" },
  { label: "Spain", value: "ES" },
  { label: "Sri Lanka", value: "LK" },
  { label: "Sudan", value: "SD" },
  { label: "Suriname", value: "SR" },
  { label: "Svalbard and Jan Mayen", value: "SJ" },
  { label: "Swaziland", value: "SZ" },
  { label: "Sweden", value: "SE" },
  { label: "Switzerland", value: "CH" },
  { label: "Syrian Arab Republic", value: "SY" },
  { label: "Taiwan, Province of China", value: "TW" },
  { label: "Tajikistan", value: "TJ" },
  { label: "Tanzania, United Republic of", value: "TZ" },
  { label: "Thailand", value: "TH" },
  { label: "Timor-Leste", value: "TL" },
  { label: "Togo", value: "TG" },
  { label: "Tokelau", value: "TK" },
  { label: "Tonga", value: "TO" },
  { label: "Trinidad and Tobago", value: "TT" },
  { label: "Tunisia", value: "TN" },
  { label: "Turkey", value: "TR" },
  { label: "Turkmenistan", value: "TM" },
  { label: "Turks and Caicos Islands", value: "TC" },
  { label: "Tuvalu", value: "TV" },
  { label: "Uganda", value: "UG" },
  { label: "Ukraine", value: "UA" },
  { label: "United Arab Emirates", value: "AE" },
  { label: "United Kingdom", value: "GB" },
  { label: "United States", value: "US" },
  { label: "United States Minor Outlying Islands", value: "UM" },
  { label: "Uruguay", value: "UY" },
  { label: "Uzbekistan", value: "UZ" },
  { label: "Vanuatu", value: "VU" },
  { label: "Venezuela", value: "VE" },
  { label: "Viet Nam", value: "VN" },
  { label: "Virgin Islands, British", value: "VG" },
  { label: "Virgin Islands, U.S.", value: "VI" },
  { label: "Wallis and Futuna", value: "WF" },
  { label: "Western Sahara", value: "EH" },
  { label: "Yemen", value: "YE" },
  { label: "Zambia", value: "ZM" },
  { label: "Zimbabwe", value: "ZW" },
];

const countryKeywords: Partial<Record<IsoCountryCode, readonly string[]>> = {
  AF: ["afghanistan"],
  AX: ["aland islands", "aland"],
  AL: ["albania", "shqiperia"],
  DZ: ["algeria", "algerie"],
  AS: ["american samoa"],
  AD: ["andorra"],
  AO: ["angola"],
  AI: ["anguilla"],
  AQ: ["antarctica"],
  AG: ["antigua and barbuda", "antigua"],
  AR: ["argentina"],
  AM: ["armenia", "hayastan"],
  AW: ["aruba"],
  AU: ["australia", "aus", "oz"],
  AT: ["austria", "osterreich"],
  AZ: ["azerbaijan", "azarbaycan"],
  BS: ["bahamas", "the bahamas"],
  BH: ["bahrain"],
  BD: ["bangladesh"],
  BB: ["barbados"],
  BY: ["belarus"],
  BE: ["belgium", "belgique", "belgie"],
  BZ: ["belize"],
  BJ: ["benin"],
  BM: ["bermuda"],
  BT: ["bhutan"],
  BO: ["bolivia", "bolivia (plurinational state of)", "plurinational state of bolivia"],
  BA: ["bosnia and herzegovina", "bosnia", "herzegovina", "bih"],
  BW: ["botswana"],
  BV: ["bouvet island"],
  BR: ["brazil", "brasil"],
  IO: ["british indian ocean territory"],
  VG: ["british virgin islands", "virgin islands, british", "virgin islands (british)"],
  BN: ["brunei", "brunei darussalam"],
  BG: ["bulgaria"],
  BF: ["burkina faso"],
  BI: ["burundi"],
  KH: ["cambodia", "kampuchea"],
  CM: ["cameroon", "cameroun"],
  CA: ["canada"],
  CV: ["cape verde", "cabo verde"],
  KY: ["cayman islands"],
  CF: ["central african republic", "centrafrique", "car"],
  TD: ["chad", "tchad"],
  CL: ["chile"],
  CN: ["china", "people's republic of china", "prc", "zhongguo"],
  CX: ["christmas island"],
  CC: ["cocos (keeling) islands", "cocos islands", "keeling islands"],
  CO: ["colombia"],
  KM: ["comoros"],
  CK: ["cook islands"],
  CR: ["costa rica"],
  HR: ["croatia", "hrvatska"],
  CU: ["cuba"],
  CY: ["cyprus", "kypros"],
  CZ: ["czechia", "czech republic", "cesko"],
  DK: ["denmark", "danmark"],
  DJ: ["djibouti"],
  DM: ["dominica"],
  DO: ["dominican republic", "republica dominicana", "repdom"],
  CD: ["democratic republic of the congo", "democratic republic of congo", "dr congo", "drc", "congo - kinshasa", "congo-kinshasa", "congo, the democratic republic of the", "congo (the democratic republic of the)", "zaire"],
  EC: ["ecuador"],
  EG: ["egypt", "misr", "masr"],
  SV: ["el salvador"],
  GQ: ["equatorial guinea", "guinea ecuatorial"],
  ER: ["eritrea"],
  EE: ["estonia", "eesti"],
  SZ: ["eswatini", "swaziland"],
  ET: ["ethiopia"],
  FK: ["falkland islands", "falkland islands (malvinas)", "malvinas"],
  FO: ["faroe islands", "foroyar"],
  FJ: ["fiji"],
  FI: ["finland", "suomi"],
  FR: ["france"],
  GF: ["french guiana", "guyane"],
  PF: ["french polynesia", "tahiti", "polynesie francaise"],
  TF: ["french southern territories"],
  GA: ["gabon"],
  GM: ["gambia", "the gambia"],
  GE: ["georgia", "sakartvelo"],
  DE: ["germany", "deutschland"],
  GH: ["ghana"],
  GI: ["gibraltar"],
  GR: ["greece", "hellas", "ellada"],
  GL: ["greenland", "kalaallit nunaat"],
  GD: ["grenada"],
  GP: ["guadeloupe"],
  GU: ["guam"],
  GT: ["guatemala"],
  GG: ["guernsey"],
  GN: ["guinea", "guinee"],
  GW: ["guinea-bissau", "guinea bissau"],
  GY: ["guyana"],
  HT: ["haiti"],
  HM: ["heard island and mcdonald islands"],
  HN: ["honduras"],
  HK: ["hong kong", "hong kong sar china", "hksar"],
  HU: ["hungary", "magyarorszag"],
  IS: ["iceland", "island"],
  IN: ["india", "bharat", "hindustan"],
  ID: ["indonesia"],
  IR: ["iran", "iran, islamic republic of", "iran (islamic republic of)", "islamic republic of iran"],
  IQ: ["iraq"],
  IE: ["ireland", "republic of ireland", "eire"],
  IM: ["isle of man"],
  IL: ["israel"],
  IT: ["italy", "italia"],
  CI: ["ivory coast", "cote d'ivoire", "cote divoire"],
  JM: ["jamaica"],
  JP: ["japan", "nippon", "nihon"],
  JE: ["jersey"],
  JO: ["jordan"],
  KZ: ["kazakhstan", "qazaqstan"],
  KE: ["kenya"],
  KI: ["kiribati"],
  KW: ["kuwait"],
  KG: ["kyrgyzstan", "kyrgyz republic"],
  LA: ["laos", "lao people's democratic republic"],
  LV: ["latvia", "latvija"],
  LB: ["lebanon", "lubnan"],
  LS: ["lesotho"],
  LR: ["liberia"],
  LY: ["libya", "libyan arab jamahiriya"],
  LI: ["liechtenstein"],
  LT: ["lithuania", "lietuva"],
  LU: ["luxembourg", "luxemburg"],
  MO: ["macau", "macao", "macao sar china"],
  MG: ["madagascar", "madagasikara"],
  MW: ["malawi"],
  MY: ["malaysia"],
  MV: ["maldives"],
  ML: ["mali"],
  MT: ["malta"],
  MH: ["marshall islands"],
  MQ: ["martinique"],
  MR: ["mauritania"],
  MU: ["mauritius", "maurice"],
  YT: ["mayotte"],
  MX: ["mexico"],
  FM: ["micronesia", "micronesia, federated states of", "micronesia (federated states of)", "federated states of micronesia"],
  MD: ["moldova", "moldova, republic of", "moldova (the republic of)", "republic of moldova"],
  MC: ["monaco"],
  MN: ["mongolia"],
  MS: ["montserrat"],
  MA: ["morocco", "maroc", "al maghrib"],
  MZ: ["mozambique", "mocambique"],
  MM: ["myanmar", "myanmar (burma)", "burma"],
  NA: ["namibia"],
  NR: ["nauru"],
  NP: ["nepal"],
  NL: ["netherlands", "the netherlands", "netherlands (kingdom of the)", "holland", "nederland"],
  NC: ["new caledonia", "nouvelle caledonie"],
  NZ: ["new zealand", "aotearoa"],
  NI: ["nicaragua"],
  NE: ["niger"],
  NG: ["nigeria", "naija"],
  NU: ["niue"],
  NF: ["norfolk island"],
  KP: ["north korea", "korea, democratic people's republic of", "korea (the democratic people's republic of)", "democratic people's republic of korea", "dprk"],
  MK: ["north macedonia", "macedonia", "macedonia, the former yugoslav republic of", "republic of north macedonia"],
  MP: ["northern mariana islands", "cnmi", "saipan"],
  NO: ["norway", "norge", "noreg"],
  OM: ["oman"],
  PK: ["pakistan"],
  PW: ["palau", "belau"],
  PS: ["palestine", "palestinian territories", "palestinian territory, occupied", "palestine, state of", "state of palestine"],
  PA: ["panama"],
  PG: ["papua new guinea", "png"],
  PY: ["paraguay"],
  PE: ["peru"],
  PH: ["philippines", "the philippines", "pilipinas", "filipinas"],
  PN: ["pitcairn islands", "pitcairn"],
  PL: ["poland", "polska"],
  PT: ["portugal"],
  PR: ["puerto rico", "boriken"],
  QA: ["qatar"],
  CG: ["republic of the congo", "republic of congo", "congo", "congo - brazzaville", "congo-brazzaville"],
  RE: ["reunion"],
  RO: ["romania"],
  RU: ["russia", "russian federation"],
  RW: ["rwanda"],
  SH: ["saint helena", "saint helena, ascension and tristan da cunha", "st helena", "ascension", "tristan da cunha"],
  KN: ["saint kitts and nevis", "st kitts and nevis", "st kitts"],
  LC: ["saint lucia", "st lucia"],
  PM: ["saint pierre and miquelon"],
  VC: ["saint vincent and the grenadines", "st vincent", "svg"],
  WS: ["samoa", "western samoa"],
  SM: ["san marino"],
  ST: ["sao tome and principe", "sao tome"],
  SA: ["saudi arabia", "kingdom of saudi arabia", "ksa"],
  SN: ["senegal"],
  SC: ["seychelles"],
  SL: ["sierra leone"],
  SG: ["singapore", "sgp"],
  SK: ["slovakia", "slovensko", "slovak republic"],
  SI: ["slovenia", "slovenija"],
  SB: ["solomon islands"],
  SO: ["somalia", "soomaaliya"],
  ZA: ["south africa", "rsa", "mzansi"],
  GS: ["south georgia and the south sandwich islands"],
  KR: ["south korea", "korea, republic of", "korea (the republic of)", "republic of korea", "rok", "korea", "hanguk"],
  ES: ["spain", "espana"],
  LK: ["sri lanka", "ceylon"],
  SD: ["sudan"],
  SR: ["suriname", "surinam"],
  SJ: ["svalbard and jan mayen"],
  SE: ["sweden", "sverige"],
  CH: ["switzerland", "suisse", "schweiz", "svizzera"],
  SY: ["syria", "syrian arab republic"],
  TW: ["taiwan", "taiwan, province of china", "taiwan (province of china)", "republic of china"],
  TJ: ["tajikistan", "tojikiston"],
  TZ: ["tanzania", "tanzania, united republic of", "tanzania, the united republic of", "united republic of tanzania"],
  TH: ["thailand", "siam"],
  TL: ["timor-leste", "timor leste", "east timor"],
  TG: ["togo"],
  TK: ["tokelau"],
  TO: ["tonga"],
  TT: ["trinidad and tobago"],
  TN: ["tunisia", "tunisie", "tunis"],
  TR: ["turkey", "turkiye", "republic of turkey"],
  TM: ["turkmenistan"],
  TC: ["turks and caicos islands", "turks and caicos", "tci"],
  TV: ["tuvalu"],
  UM: ["u.s. minor outlying islands", "u.s. outlying islands", "united states minor outlying islands", "us outlying islands"],
  VI: ["u.s. virgin islands", "virgin islands, u.s.", "virgin islands (u.s.)", "united states virgin islands", "usvi"],
  UG: ["uganda"],
  UA: ["ukraine", "ukraina"],
  AE: ["united arab emirates", "uae", "dubai", "abu dhabi", "emirates"],
  GB: ["uk", "gb", "gbr", "united kingdom", "united kingdom of great britain and northern ireland", "great britain", "britain", "england", "scotland", "wales", "northern ireland"],
  US: ["us", "usa", "united states", "united states of america", "america"],
  UY: ["uruguay"],
  UZ: ["uzbekistan", "ozbekiston"],
  VU: ["vanuatu"],
  VA: ["vatican city", "holy see", "holy see (vatican city state)", "vatican"],
  VE: ["venezuela", "venezuela (bolivarian republic of)", "bolivarian republic of venezuela"],
  VN: ["vietnam", "viet nam"],
  WF: ["wallis and futuna"],
  EH: ["western sahara", "western sahara*"],
  YE: ["yemen"],
  ZM: ["zambia"],
  ZW: ["zimbabwe"],
};

const countryFlag = (countryCode: string): string => {
  const codePoints = countryCode
    .toUpperCase()
    .split("")
    .map((char) => 127397 + char.charCodeAt(0));
  return String.fromCodePoint(...codePoints);
};

export type Country = {
  label: string;
  value: IsoCountryCode;
  keywords: readonly string[];
  flag: string;
};

export const countries: Country[] = countryDefinitions.map((country) => ({
  label: country.label,
  value: country.value,
  keywords: countryKeywords[country.value] ?? [],
  flag: countryFlag(country.value),
}));

/**
 * Normalises a country name or code for case-, diacritic-, and punctuation-
 * insensitive comparison (`"España"` → `"espana"`, `"Côte d’Ivoire"` →
 * `"cote d'ivoire"`, `"Bosnia & Herzegovina"` → `"bosnia and herzegovina"`).
 */
export const normalizeCountryLookupKey = (value: string): string =>
  value
    .trim()
    .toLowerCase()
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .replace(/['’`]/g, "'")
    .replace(/\s*\(the\)\s*/g, " ")
    .replace(/\s*&\s*/g, " and ")
    .replace(/\bst\.\s+/g, "saint ")
    .replace(/\s+/g, " ")
    .trim();

const countryCodeByAlias: ReadonlyMap<string, IsoCountryCode> = (() => {
  const map = new Map<string, IsoCountryCode>();
  for (const country of countries) {
    map.set(normalizeCountryLookupKey(country.value), country.value);
    map.set(normalizeCountryLookupKey(country.label), country.value);
    for (const keyword of country.keywords) {
      const key = normalizeCountryLookupKey(keyword);
      if (!map.has(key)) {
        map.set(key, country.value);
      }
    }
  }
  return map;
})();

/** Resolves a country name, ISO code, or known alias to its ISO 3166-1 alpha-2 code. */
export const resolveCountryCode = (value: string): IsoCountryCode | null => {
  const key = normalizeCountryLookupKey(value);
  if (!key) {
    return null;
  }
  return countryCodeByAlias.get(key) ?? null;
};

export const formatCountryCodeFromString = (
  country: string,
): IsoCountryCode | null => {
  const matchedCountry = countries.find(
    (c) => c.label.toLowerCase() === country.toLowerCase(),
  );
  return matchedCountry ? matchedCountry.value : null;
};

/**
 * All European country codes that we support for EUR currency filtering.
 * Includes EU member states, EEA countries, and nearby European nations.
 */
export const EUROPEAN_COUNTRY_CODES = [
  "AL", // Albania
  "AD", // Andorra
  "AT", // Austria
  "BY", // Belarus
  "BE", // Belgium
  "BA", // Bosnia and Herzegovina
  "BG", // Bulgaria
  "HR", // Croatia
  "CY", // Cyprus
  "CZ", // Czechia (Czech Republic)
  "DK", // Denmark
  "EE", // Estonia
  "FI", // Finland
  "FR", // France
  "DE", // Germany
  "GR", // Greece
  "HU", // Hungary
  "IS", // Iceland
  "IE", // Ireland
  "IT", // Italy
  "XK", // Kosovo
  "LV", // Latvia
  "LI", // Liechtenstein
  "LT", // Lithuania
  "LU", // Luxembourg
  "MT", // Malta
  "MD", // Moldova
  "MC", // Monaco
  "ME", // Montenegro
  "NL", // Netherlands
  "MK", // North Macedonia
  "NO", // Norway
  "PL", // Poland
  "PT", // Portugal
  "RO", // Romania
  "RU", // Russia
  "SM", // San Marino
  "RS", // Serbia
  "SK", // Slovakia
  "SI", // Slovenia
  "ES", // Spain
  "SE", // Sweden
  "CH", // Switzerland
  "UA", // Ukraine
  "VA", // Vatican City
  "GB", // United Kingdom
] as const;

/**
 * Country codes a workspace's suggested creators are drawn from, by its
 * currency: GBP → UK, USD → US, EUR → Europe (the list above, UK included).
 * Accepts the lowercase values stored on `Campaigns.currency`; anything
 * unrecognised falls back to the UK, like the Discover page's default
 * country filter.
 */
export const getCountryCodesForCurrency = (
  currency: string | null | undefined,
): readonly string[] => {
  switch (currency?.toUpperCase()) {
    case "USD":
      return ["US"];
    case "EUR":
      return EUROPEAN_COUNTRY_CODES;
    default:
      return ["GB"];
  }
};
